import * as APITypes from "~/API";
import { apiClient } from "~/services/apiClient";

export interface SubscriptionLoaderResult {
  subscriptionPlan: APITypes.SubscriptionPlan;
  hasServiceRequestAccess: boolean;
  hasFinanceAccess: boolean;
}

/**
 * Default FreeTier plan (fallback when subscription not found)
 */
const DEFAULT_FREETIER_PLAN: APITypes.SubscriptionPlan = {
  __typename: "SubscriptionPlan",
  id: "freetier-default",
  name: "FreeTier",
  description: "Free tier subscription plan",
  price: 0,
  isActive: true,
  features: [],
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  _version: 1,
  _lastChangedAt: Math.floor(Date.now() / 1000),
};

/**
 * Get user's subscription plan using Lambda API loader endpoint.
 * This is the preferred method for fetching subscription data as it uses the Lambda API
 * instead of Amplify GraphQL, ensuring consistency with other API calls.
 *
 * @param userID - The user's ID
 * @returns The user's subscription plan (or FreeTier if no active subscription or on error)
 */
export const getUserSubscriptionWithLambda = async (
  userID: string
): Promise<APITypes.SubscriptionPlan> => {
  if (!userID) {
    return DEFAULT_FREETIER_PLAN;
  }

  try {
    const result = await apiClient.loader<SubscriptionLoaderResult>(
      "subscription",
      { id: userID }
    );

    if (!result.success || !result.data) {
      console.error("Failed to load subscription:", result.error);
      return DEFAULT_FREETIER_PLAN;
    }

    return result.data.subscriptionPlan;
  } catch (error) {
    console.error("Error getting user subscription:", error);
    return DEFAULT_FREETIER_PLAN;
  }
};
